import { Injectable } from '@angular/core';

type PickFileResponse = { result: 'success'; file: File } | { result: 'cancelled' } | { result: 'error' };

@Injectable({
	providedIn: 'root'
})
export class BrowserFileHandlerService {
	public pickFileForOpen(fileExtensions: string[]): Promise<PickFileResponse> {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = fileExtensions.join(',');

		return new Promise<PickFileResponse>((resolve) => {
			input.onchange = (): void => {
				if (input.files === null || input.files.length === 0) {
					resolve({
						result: 'error'
					});
					return;
				}

				const file = input.files[0];
				resolve({
					result: 'success',
					file: file
				});
			};

			input.oncancel = (): void => {
				resolve({
					result: 'cancelled'
				});
			};

			input.click();
		});
	}

	public downloadFile(suggestedFileName: string, fileContent: string, mimeType: string, fileExtension: string): void {
		const blob = new Blob([fileContent], { type: mimeType });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = url;

		// Browser usually automatically adds an extension based on the blob type ex: application/json, text/csv.
		// But if file name contains a dot, it seems to assume that the string after the dot to be the extension.
		// So here we are manually adding the file extension.
		link.download = `${suggestedFileName}.${fileExtension}`;

		document.body.appendChild(link);

		link.click();

		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}
}
